var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ReplyAbstractComponent } from '../reply-abstract.component';
import { BalanceHistoryService } from '../../../../core/account/balance-history.service';
import { SocketService } from '../../../../core/socket.service';
import cardMap from '@app/_v2/games/hi-lo/card-map';
var MersenneTwister = require('mersennetwister');
var ReplyHiLoComponent = /** @class */ (function (_super) {
    __extends(ReplyHiLoComponent, _super);
    function ReplyHiLoComponent(socket, balanceHistory) {
        var _this = _super.call(this, socket, balanceHistory) || this;
        _this.socket = socket;
        _this.balanceHistory = balanceHistory;
        _this.DECK_LENGTH = 52;
        _this.DECKS = 12;
        _this.luckyCards = [];
        return _this;
    }
    ReplyHiLoComponent.prototype.generateLuckyGameCards = function (clientSeed, serverSeed, length) {
        clientSeed = clientSeed.replace('0x', '');
        serverSeed = serverSeed.replace('0x', '');
        var clSeedSplitted = clientSeed.match(/.{1,6}/g);
        var srvSeedSplitted = serverSeed.match(/.{1,6}/g);
        var seedsCombined = clSeedSplitted.concat(srvSeedSplitted);
        for (var i = 0; i < seedsCombined.length; i++) {
            seedsCombined[i.toString()] = parseInt(seedsCombined[i], 16);
        }
        var mt = new MersenneTwister();
        mt.seedArray(seedsCombined);
        var arr = [];
        for (var i = 0; i < this.DECK_LENGTH; i++) {
            arr.push(i);
        }
        var tempArr = JSON.parse(JSON.stringify(arr));
        // Using 12 decks where in each deck are 52 cards
        for (var i = 0; i < this.DECKS - 1; i++) {
            arr = tempArr.concat(arr);
        }
        // Shuffle 12 decks
        var finalArr = [];
        var leftToShuffle = arr.length;
        while (leftToShuffle !== 0) {
            var randomCard = mt.int() % leftToShuffle;
            finalArr.push(arr[randomCard]);
            arr.splice(randomCard, 1);
            --leftToShuffle;
        }
        return finalArr.slice(0, length);
    };
    ReplyHiLoComponent.prototype.getCardName = function (card) {
        return cardMap[card];
    };
    // specified game
    ReplyHiLoComponent.prototype.initialize = function (data) {
        if (data) {
            if (data.game !== 'hi-lo') {
                this._error = true;
                return;
            }
            this.luckyCards = data.gameData.deck;
            this._loading = false;
        }
        this.generateGame();
    };
    // not specified game
    ReplyHiLoComponent.prototype.generateGame = function () {
        this.luckyCards = this.generateLuckyGameCards(this.playerSeed, this.serverSeed, 20);
        this._loading = false;
    };
    return ReplyHiLoComponent;
}(ReplyAbstractComponent));
export { ReplyHiLoComponent };



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/components/reply/reply-hi-lo/reply-hi-lo.component.ts.pre-build-optimizer.js